import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from 'react';
import { resolveErrorMessage } from '@paysera/error-message-resolver';
import useCancelablePromise from "./useCancelablePromise";
import useLoaderState from "./useLoaderState";
import { isCanceledPromise } from "../service/cancelablePromiseManager";
var useFetchData = function useFetchData(fetchData, errorHandler, errorMessageConfig) {
  var variables = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var _useCancelablePromise = useCancelablePromise(),
    addCancelablePromise = _useCancelablePromise.addCancelablePromise;
  var _useLoaderState = useLoaderState(false),
    isLoaded = _useLoaderState.isLoaded,
    start = _useLoaderState.start,
    stop = _useLoaderState.stop;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];
  var fetchDataAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resolver, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            start();
            resolver = addCancelablePromise(Promise.resolve(fetchData()));
            _context.t0 = setResult;
            _context.next = 6;
            return resolver;
          case 6:
            _context.t1 = _context.sent;
            (0, _context.t0)(_context.t1);
            errorHandler.clearError();
            _context.next = 24;
            break;
          case 11:
            _context.prev = 11;
            _context.t2 = _context["catch"](0);
            if (!isCanceledPromise(_context.t2)) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            _context.t3 = resolveErrorMessage;
            _context.t4 = _context.t2;
            _context.next = 19;
            return errorMessageConfig;
          case 19:
            _context.t5 = _context.sent;
            _context.next = 22;
            return (0, _context.t3)(_context.t4, _context.t5);
          case 22:
            errorMessage = _context.sent;
            errorHandler.dispatchError(errorMessage, _context.t2);
          case 24:
            _context.prev = 24;
            stop();
            return _context.finish(24);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 11, 24, 27]]);
    }));
    return function fetchDataAction() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchDataAction();
  }, variables);
  return {
    loaded: isLoaded(),
    result: result,
    reload: fetchDataAction
  };
};
export default useFetchData;